module.exports = __webpack_public_path__ + "static/media/logo.411d851c.png";